import './HRow.css';

import React from 'react';
import cn from 'classnames';

interface Props {
  children?: React.ReactNode;
  marginRight?: number;
}

/**
 * Helper component to align child components horizontally
 * @param props marginRight - gap between two components. should be multiple of 3
 */
const HRow: React.SFC<Props> = (props: Props) => (
  <div
    className={cn('hrow-main', {
      [`hrow-margin-right-${
        props.marginRight !== undefined ? props.marginRight : 9
      }`]: true
    })}
  >
    {props.children}
  </div>
);

export default HRow;
